import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function Evolution() {
  const points = ['Clear business strategy', 'Real revenue opportunities', 'Community accountability', 'Systems that create wealth, not burnout'];
  return <section className="py-24 lg:py-32 bg-navy text-cream overflow-hidden" data-id="element-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-14">
          <div className="order-2 lg:order-1" data-id="element-15">
            <FadeIn data-id="element-16">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-10 leading-tight text-white" data-id="element-17">
                From Side Hustle to <br data-id="element-18" />
                Lead<em className="font-light italic text-gold-light" data-id="element-19">Her</em>
                Ship
              </h2>
            </FadeIn>

            <div className="space-y-8 text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-20">
              <FadeIn delay={0.1} data-id="element-21">
                <p data-id="element-22">
                  What started as a space for women exploring entrepreneurship
                  has evolved into something bigger.
                </p>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-23">
                <p data-id="element-24">
                  LeadHerShip Equity exists for women who are ready to move
                  beyond side hustles and into ownership, leadership, and
                  scalable income.
                </p>
              </FadeIn>

              <FadeIn delay={0.3} data-id="element-25">
                <p className="font-medium text-white mt-12 mb-6 tracking-wide uppercase text-sm" data-id="element-26">
                  We believe women deserve access to:
                </p>
              </FadeIn>

              <StaggerContainer className="space-y-4 mb-12" data-id="element-27">
                {points.map((point, index) => <StaggerItem key={index} className="flex items-start" data-id="element-28">
                    <span className="text-gold-light mr-4 text-2xl leading-none" data-id="element-29">
                      •
                    </span>
                    <span className="text-cream" data-id="element-30">{point}</span>
                  </StaggerItem>)}
              </StaggerContainer>

              <FadeIn delay={0.4} className="mt-16 pt-8 border-t border-white/20" data-id="element-31">
                <p className="font-serif italic text-2xl text-white mb-2" data-id="element-32">
                  This is not about chasing trends.
                </p>
                <p className="font-serif italic text-2xl text-white" data-id="element-33">
                  This is about building businesses with structure, strategy,
                  and long-term impact.
                </p>
              </FadeIn>
            </div>
          </div>

          <FadeIn direction="left" className="order-1 lg:order-2 relative w-full" data-id="element-34">
            <div className="absolute inset-0 bg-blush/25 translate-x-4 translate-y-4 lg:translate-x-8 lg:translate-y-8" data-id="element-35"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7VS6PbVQmWMXBjcepbNt1Q/SHM_Posts_June_(9).png" alt="LeadHerShip Equity events and community highlights" className="relative w-full h-auto shadow-2xl" data-id="element-36" />
          </FadeIn>
        </div>
      </div>
    </section>;
}